"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _GLSL = _interopRequireDefault(require("./GLSL"));

var _Shaders = _interopRequireDefault(require("./Shaders"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _Shaders.default.create({
  copy: {
    frag: (0, _GLSL.default)`
precision highp float;
varying vec2 uv;
uniform sampler2D t;
void main(){
  gl_FragColor=texture2D(t,uv);
}`
  }
}).copy;

exports.default = _default;
//# sourceMappingURL=copyShader.js.map